import { render, staticRenderFns } from "./NewAlerts.vue?vue&type=template&id=5cb7f0d0&"
import script from "./NewAlerts.vue?vue&type=script&lang=js&"
export * from "./NewAlerts.vue?vue&type=script&lang=js&"
import style0 from "./NewAlerts.vue?vue&type=style&index=0&id=5cb7f0d0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports